import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from "prop-types";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";

class AlarmsTableColumnSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleColumns: props.visibleColumns
        ? [...props.visibleColumns]
        : props.columns.map(c => c.id),
    };
  }

  handleColumnChange = event => {
    const id = event.target.value;
    let visibleColumns = this.state.visibleColumns;
    if (visibleColumns.includes(id)) {
      visibleColumns = visibleColumns.filter(c => c !== id);
    } else {
      visibleColumns = [...visibleColumns, id];
    }
    this.setState({ visibleColumns });
  };

  handleUpdate = () => {
    this.props.handleUpdate(this.state.visibleColumns);
    this.props.handleClose();
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        fullWidth={false}
        maxWidth="xs"
      >
        <DialogTitle>
          <FormattedMessage id="alarm.column_selector" />
        </DialogTitle>
        <DialogContent>
          <FormGroup>
            {this.props.columns.map(column => (
              <FormControlLabel
                key={column.id}
                control={
                  <Checkbox
                    color="primary"
                    checked={this.state.visibleColumns.includes(column.id)}
                    onChange={this.handleColumnChange}
                    value={column.id}
                  />
                }
                label={column.label}
              />
            ))}
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose} color="secondary">
            <FormattedMessage id="cancel" />
          </Button>
          <Button onClick={this.handleUpdate} color="primary" autoFocus>
            <FormattedMessage id="ok" />
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

AlarmsTableColumnSelector.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  visibleColumns: PropTypes.array,
  handleUpdate: PropTypes.func.isRequired,
};

export default injectIntl(AlarmsTableColumnSelector);
